<template>
    <div class="main-container">
        <div id="loading-container" class="loading-container" v-if="isLoaderActive">
            <Loader class="loader"></Loader>
        </div>
        <Publications v-if="loaded && type === 'publications'" :title="'Publicações'" :publications="publications"/>
        <Articles v-if="loaded && type === 'publications'" :title="'Artigos'" :articles="articles"/>
        <GuidedTourList v-if="type === 'guided-tours'" :guidedTours="guidedTours"></GuidedTourList>
    </div>
</template>

<script>
    import Publications from "../main/Publications";
    import GuidedTourList from "../main/GuidedTourList";
    import contentHelper from "../../helpers/content.helper";
    import {forkJoin} from "rxjs";
    import Articles from "../main/Articles";
    import anime from "animejs";
    import Loader from "../generic/Loader";

    export default {
        name: "ListPage",
        components: {GuidedTourList, Publications, Articles, Loader},
        watch: {
            '$route.path': function () {
                this.loaded = false;
                this.getType();
                this.loadData();
            }
        },
        data() {
          return {
              type: null,
              guidedTours: null,
              publications: null,
              articles: null,
              loaded: false,
              isLoaderActive: true
          }
        },
        beforeMount() {
            this.loadPage();
        },
        created() {
            this.getType();
        },
        methods: {
            loadPage() {
                this.showLoader().then( () => this.loadData());
            },
            getType() {
                this.type = this.$route.path.substr(1);
            },
            loadData() {
                if (this.type === 'guided-tours') {
                    this.loadGuidedTours().then(entries => {
                        this.guidedTours = entries;
                        this.loaded = true;
                        setTimeout(() => this.hideLoader(), 500);
                    });
                } else if (this.type === 'publications') {
                    forkJoin([this.loadPublications(), this.loadArticles()])
                        .subscribe(value => {
                            this.publications = value[0];
                            this.articles = value[1];
                            this.loaded = true;
                            setTimeout(() => this.hideLoader(), 500);
                        },
                            //TODO - send to log platform
                        error => console.log(error));

                }
            },
            loadPublications() {
                return contentHelper.client
                    .getEntries({
                        content_type: 'publication',
                        order: 'fields.order'
                    });
            },
            loadArticles() {
                return contentHelper.client
                    .getEntries({
                        content_type: 'article',
                        order: '-fields.order'
                    });
            },
            loadGuidedTours() {
                return contentHelper.client
                    .getEntries({
                        content_type: 'guidedTourEntry',
                        order: 'fields.order'
                    });
            },
            showLoader() {
                this.isLoaderActive = true;
                const element = document.querySelector("#loading-container");

                return anime({
                    targets: element,
                    opacity: 1,
                    duration: 300,
                    easing: 'easeOutQuad'
                }).finished;
            },
            hideLoader() {
                const element = document.querySelector("#loading-container");

                anime({
                    targets: element,
                    opacity: this.loading ? 1 : 0,
                    duration: 500,
                    easing: 'easeOutQuad'
                }).finished.then(() => { this.isLoaderActive = false });
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/global";


    .loading-container {
        position: absolute;
        opacity: 1;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background-color: $primary;
        z-index: 98;

        .loader {
            position: relative;
            top: 50%;
        }
    }

    @media only screen and (max-width: 767px) {
        .loading-container {
            margin-top: $mobile-bar-height;
            margin-bottom: -30%;

            .loader {
                top: 30%;
            }
        }
    }


</style>
